(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    (function() {
  // Read map from JSON (no Liquid inside this JS block)
  function getVariantGalleryMap() {
    if (window.__FS_GALLERY_MAP__) return window.__FS_GALLERY_MAP__;
    var el = document.querySelector('script[id^="FSVariantGalleryMap-"]');
    if (!el) return null;
    try {
      window.__FS_GALLERY_MAP__ = JSON.parse(el.textContent || el.innerText || '{}');
      return window.__FS_GALLERY_MAP__;
    } catch (e) { return null; }
  }

  function getSelectedVariantId() {
    var idInput = document.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getSelectedColor() {
    var radioChecked = document.querySelector('input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="colour"]:checked');
    if (radioChecked) return radioChecked.value.trim().toLowerCase();
    var selects = Array.from(document.querySelectorAll('select[name^="options["]'));
    var colorSelect = selects.find(function(sel){
      var name = sel.getAttribute('name') || '';
      if (/color|colour/i.test(name)) return true;
      var wrap = sel.closest('[data-option-name]');
      return wrap && /color|colour/i.test(wrap.getAttribute('data-option-name') || '');
    });
    if (colorSelect) {
      var txt = colorSelect.options[colorSelect.selectedIndex].text || colorSelect.value;
      return String(txt).trim().toLowerCase();
    }
    return null;
  }

  // Create a .product-media wrapper for a raw file URL
  function createMediaEl(fileUrl, fileName, variantId, color) {
    var wrap = document.createElement('div');
    // many themes wrap in a container; adding our own keeps layout flexible
    var container = document.createElement('div');
    container.className = 'product-media';
    container.setAttribute('data-media-id', 'fs-' + (fileName || Math.random().toString(36).slice(2)));
    container.setAttribute('data-media-variant-ids', variantId ? String(variantId) : '');
    if (fileName) container.setAttribute('data-media-filename', fileName.toLowerCase());
    if (color) container.setAttribute('data-media-color', color);

    // Use a safe default ratio; CSS falls back to --gallery-aspect-ratio if present
    container.setAttribute('style', '--ratio: 1;');

    var img = document.createElement('img');
    img.className = 'product-media__image';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = '';
    img.src = fileUrl;

    container.appendChild(img);
    wrap.appendChild(container);
    // If your theme expects a .product-media-container wrapper, keep this class present:
    wrap.className = 'product-media-container';
    return wrap;
  }

  // Ensure all metafield files exist as slides
  function materializeMetafieldSlides() {
    var map = getVariantGalleryMap();
    if (!map) return;

    var anyMedia = document.querySelector('.product-media');
    if (!anyMedia) return;

    var galleryParent = anyMedia.parentElement; // parent that already contains media items
    if (!galleryParent) return;

    // Build a set of filenames already present
    var existingNames = new Set(Array.from(document.querySelectorAll('.product-media[data-media-filename]'))
      .map(function(el){ return (el.getAttribute('data-media-filename') || '').toLowerCase(); })
      .filter(Boolean));

    // Append missing files as new slides
    for (var vid in map.variantToFiles) {
      var files = map.variantToFiles[vid] || [];
      var color = (map.variantToColor && map.variantToColor[vid]) ? map.variantToColor[vid] : null;

      files.forEach(function(f){
        // f is {name, url}
        var name = (f && f.name) ? String(f.name).toLowerCase() : '';
        var url  = (f && f.url)  ? String(f.url)  : '';
        if (!url) return;

        if (!existingNames.has(name)) {
          var node = createMediaEl(url, name, vid, color);
          galleryParent.appendChild(node);
          existingNames.add(name);
        }
      });
    }
  }

  // Hide/show slides for the current selection
  function filterGallery(variantId) {
    var map = getVariantGalleryMap() || { variantToFiles: {}, variantToColor: {} };
    var fileObjs = map.variantToFiles && map.variantToFiles[variantId] ? map.variantToFiles[variantId] : [];
    var fileNames = Array.isArray(fileObjs) ? fileObjs.map(function(o){ return (o && o.name) ? String(o.name).toLowerCase() : ''; }) : [];
    var fileSet = new Set(fileNames.filter(Boolean));
    var selectedColor = getSelectedColor();

    var items = document.querySelectorAll('.product-media[data-media-id]');
    var anyVisible = false;
    var visibleIds = [];

    items.forEach(function(el){
      var ids = (el.getAttribute('data-media-variant-ids') || '').split(',').filter(Boolean);
      var fileName = (el.getAttribute('data-media-filename') || '').toLowerCase();
      var color = (el.getAttribute('data-media-color') || '').toLowerCase();

      var attachedToVariant = ids.length > 0 && ids.includes(String(variantId));
      var matchesMetafieldFile = fileSet.size > 0 && fileName && fileSet.has(fileName);
      var matchesColor = selectedColor && color && (color === selectedColor);
      var isGlobal = (ids.length === 0 && !fileName && !color);

      var show = isGlobal || attachedToVariant || matchesMetafieldFile;
      if (fileSet.size === 0 && ids.length === 0) {
        show = isGlobal || matchesColor;
      }

      el.style.display = show ? '' : 'none';
      if (show) { anyVisible = true; visibleIds.push(el.getAttribute('data-media-id')); }
    });

    if (!anyVisible) {
      items.forEach(function(el){ el.style.display = ''; visibleIds.push(el.getAttribute('data-media-id')); });
    }

    // Try to hide non-visible thumbnails (if present)
    var thumbs = document.querySelectorAll(
      '.media-thumbnails [data-media-id], .product-thumbnails [data-media-id], [data-thumbnails] [data-media-id], .thumbnail-nav [data-media-id]'
    );
    thumbs.forEach(function(th){
      var id = th.getAttribute('data-media-id');
      th.style.display = (!id || visibleIds.indexOf(id) !== -1) ? '' : 'none';
    });

    var firstVisible = Array.from(items).find(function(n){ return n.style.display !== 'none'; });
    if (firstVisible && window.innerWidth < 750) firstVisible.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function setColorOption(targetColor) {
    if (!targetColor) return false;
    var lc = String(targetColor).toLowerCase().trim();

    var selects = Array.from(document.querySelectorAll('select[name^="options["]'));
    var colorSelect = selects.find(function(sel){
      var name = sel.getAttribute('name') || '';
      if (/color|colour/i.test(name)) return true;
      var wrap = sel.closest('[data-option-name]');
      return wrap && /color|colour/i.test(wrap.getAttribute('data-option-name') || '');
    });
    if (colorSelect) {
      var option = Array.from(colorSelect.options).find(function(o){
        return String(o.text || o.value).toLowerCase().trim() === lc;
      });
      if (option && colorSelect.value !== option.value) {
        colorSelect.value = option.value;
        colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    var radio = Array.from(document.querySelectorAll('input[type="radio"]')).find(function(r){
      return /color|colour/i.test(r.name || '') && String(r.value).toLowerCase().trim() === lc;
    });
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  // Events
  document.addEventListener('variant:changed', function(e){
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      materializeMetafieldSlides();
      filterGallery(e.detail.variant.id);
    }
  });
  document.addEventListener('variant:change', function(e){
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      materializeMetafieldSlides();
      filterGallery(e.detail.variant.id);
    }
  });

  // Fallback watcher
  var idInput = document.querySelector('input[name="id"]');
  if (idInput) {
    var last = idInput.value;
    var obs = new MutationObserver(function() {
      if (idInput.value !== last) {
        last = idInput.value;
        materializeMetafieldSlides();
        filterGallery(last);
      }
    });
    obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  // Click photo → switch color
  document.addEventListener('click', function(e){
    var mediaEl = e.target.closest('.product-media');
    if (!mediaEl) return;

    var map = getVariantGalleryMap();
    var fileName = (mediaEl.getAttribute('data-media-filename') || '').toLowerCase();
    var colorFromAttr = (mediaEl.getAttribute('data-media-color') || '');

    if (colorFromAttr) { setColorOption(colorFromAttr); return; }

    if (map && fileName) {
      var foundVariantId = null;
      for (var vid in map.variantToFiles) {
        var arr = map.variantToFiles[vid] || [];
        if (arr.some(function(o){ return (o && o.name || '').toLowerCase() === fileName; })) { foundVariantId = vid; break; }
      }
      if (foundVariantId && map.variantToColor && map.variantToColor[foundVariantId]) {
        setColorOption(map.variantToColor[foundVariantId]);
      }
    }
  });

  // Initial pass
  document.addEventListener('DOMContentLoaded', function(){
    materializeMetafieldSlides();
    var params = new URLSearchParams(location.search);
    var id = params.get('variant') || getSelectedVariantId();
    if (id) filterGallery(id);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
